import React from 'react';
import { Callout, Flex, FlexColumn, Select as BaseSelect, Text } from 'core/components';
import { CAPABILITIES_DEFAULT_CONFIGS } from '@kentik/ui-shared/agents/constants';

const FlowExportInstructionTable = ({
  hostName,
  displayName,
  host,
  port,
  deviceName,
  indent = false,
  instructions
}) => {
  let hostStr = (
    <Text as="div" fontWeight="bold" monospace>
      {host || '<kproxy_ip_address>'}
    </Text>
  );

  if (host === CAPABILITIES_DEFAULT_CONFIGS?.kproxy?.args?.host) {
    hostStr = (
      <Text as="div" fontWeight="bold" monospace>
        Any IP on {displayName || hostName} host
      </Text>
    );
  }
  instructions = instructions || (
    <Text as="div">
      Configure {deviceName ? <strong>{deviceName}</strong> : 'this device'} to send flows to Kentik with the following
      details:
    </Text>
  );
  return (
    <>
      {instructions}
      <Flex flexDirection="column" mt={1} ml={indent ? 2 : 0}>
        <Flex>
          <Text as="div" width={180}>
            Flow Proxy Private IP:
          </Text>
          <Text as="div" fontWeight="bold" monospace>
            {hostStr}
          </Text>
        </Flex>
        <Flex>
          <Text as="div" width={180}>
            Flow Proxy port:
          </Text>
          <Text as="div" fontWeight="bold" monospace>
            {port || '<kproxy_port>'}
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

// For device Dialog
const FlowExportInstructionsForm = ({
  hostName,
  displayName,
  host,
  port,
  deviceName,
  flowProxyId,
  handleFlowProxySelect,
  ariaProps = {},
  agentOptions = []
}) => (
  <Flex flexDirection="column" gap="12px" {...ariaProps}>
    <BaseSelect
      menuWidth={310}
      placeholder="Select a Universal Agent (w/ Kproxy running) to show the private IP below"
      options={agentOptions}
      onChange={handleFlowProxySelect}
      values={flowProxyId}
    />
    {host && port && (
      <FlowExportInstructionTable
        hostName={hostName}
        displayName={displayName}
        host={host}
        port={port}
        deviceName={deviceName}
        indent
      />
    )}
  </Flex>
);

// Version for Agents page
const FlowExportInstructions = ({ latestConfig, agent }) => {
  const { host, port } = latestConfig?.argsObject ?? {};
  if (!host || !port) {
    return null;
  }
  const hostName = agent?.get('host_name');
  const displayName = agent?.get('display_name');
  const instructions = (
    <Text>For Network Devices to send flow telemetry through this proxy, please configure them to:</Text>
  );

  return (
    <FlexColumn justifyContent="space-between" m={2}>
      <Text as="div" fontWeight="bold" fontSize={14}>
        Flow Export Instructions
      </Text>
      <Callout intent="primary" p={2} mt="4px">
        <FlowExportInstructionTable
          hostName={hostName}
          displayName={displayName}
          host={host}
          port={port}
          instructions={instructions}
        />
      </Callout>
    </FlexColumn>
  );
};

export { FlowExportInstructions, FlowExportInstructionTable, FlowExportInstructionsForm };
